module.exports = __webpack_public_path__ + "media/voice.19dd327f.mp4";